exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Checkbox-module__wrapper___1U33o{display:grid;gap:.25rem;grid-auto-flow:column;justify-content:start;align-items:center;line-height:0}.Checkbox-module__checkbox___wNdda,.Checkbox-module__wrapper___1U33o .Checkbox-module__text___2hLt2{cursor:pointer}.Checkbox-module__checkbox___wNdda{width:15px;height:15px;font-size:10px;display:flex;justify-content:center;align-items:center;border-radius:3px;color:#fff;background:#ececec;transition:.2s}.Checkbox-module__checkbox___wNdda svg{transition:.2s;opacity:0}.Checkbox-module__checkbox___wNdda.Checkbox-module__checked___lxsb3{background-color:#0827e9}.Checkbox-module__checkbox___wNdda.Checkbox-module__checked___lxsb3 svg{opacity:1}.Checkbox-module__checkbox___wNdda.Checkbox-module__green___1pyoF{background-color:#2addd0}.Checkbox-module__checkbox___wNdda.Checkbox-module__green___1pyoF svg{opacity:1}", ""]);

// exports
exports.locals = {
	"wrapper": "Checkbox-module__wrapper___1U33o",
	"checkbox": "Checkbox-module__checkbox___wNdda",
	"text": "Checkbox-module__text___2hLt2",
	"checked": "Checkbox-module__checked___lxsb3",
	"green": "Checkbox-module__green___1pyoF"
};